import ApiIframe from '@/api/apiIframe'
import Vue from 'vue'
import router from '../router'

const state = {
  iframeTournament:null
}

const actions = {
  loadIframeTournament({ commit, state }, tournamentId) {
      ApiIframe.loadTournamentInfo(tournamentId,(response) => {
        commit("updateIframeTournament", response.data.data)
      }, error => {
        console.log('Error', error)
      })
  }

}

const mutations = {
  updateIframeTournament(state, data) {
    state.iframeTournament = data
  }
}

const getters = {
  currentIframeTournament(state) {
    return state.iframeTournament
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/iframe.js